<template>
     <div class="footer">
          <div class="inner-box">
               <p>成都云处方科技有限责任公司</p>
               <p>
                    <img class="icon-info" src="/static/img/address.png" alt="">
                    <span id="ycf_Address">国家"双创"示范基地·中国·四川·成都市郫都区菁蓉镇</span>
               </p>
               <p>
                    <img class="icon-info" src="/static/img/tell.png" alt="">
                    <span id="ycf_Phone">18608131878</span>
               </p>
               <p>
                    <img class="icon-info" src="/static/img/email.png" alt="">
                    <span id="ycf_Email">ycf@smis.cn</span>
               </p>
               <p>
                    <img  src="/static/img/wx.jpg" id="wechat" @click="goToWechat" style="width:79px;height:79px">
                    <img class="icon-more" src="/static/img/xl1.png" id="blog"  @click="goToBlog">
            
               </p>
          </div>
          <div class="copyright">
               <p>Copyright © 2019 成都云处方科技有限责任公司</p>
               <p>国家"双创"示范基地·中国·四川·成都市郫都区菁蓉镇</p>
               <p><a href="https://beian.miit.gov.cn">《中华人民共和国电信与信息服务业务经营许可证》编号：蜀ICP备17010625号</a></p>
          </div>
     </div>
</template>

<script>
export default {
     data() {
          return {
               
          }
     },
     methods: {
          // 微信
          goToWechat(){},
          // 微博
          goToBlog(){
               window.location.href="https://weibo.com/u/7467335947?is_hot=1"
          },
     },
}
</script>

<style scoped>
     .footer{
          /* margin-top: 60px; */
          /* background-color: #383b48; */
          min-width: 1380px;
          border-top: 1px solid #DDDDDD;
          font-family: 'PingFangSC-Regular', 'Microsoft Yahei', '微软雅黑', 'simsun', Arial;
     }
     .copyright {
          border-top: 1px solid #DDDDDD;
          text-align: center;
          font-size: 12px;
          color: #a8abb3;
          padding:20px 0;
     }
     .inner-box{width:1380px;margin-left: auto;margin-right: auto;padding: 30px 0;}
	.inner-box span{margin-left:10px}
	.inner-box p:nth-child(1){color:#eb5c01;font-size:24px}
	.inner-box p:nth-child(2){margin-top:20px;color:#a8abb3;font-size:16px}
	.inner-box p:nth-child(3){margin-top:10px;color:#a8abb3;font-size:16px}
	.inner-box p:nth-child(4){margin-top:10px;color:#a8abb3;font-size:16px}
	.inner-box p:nth-child(5) img:not(:first-child){margin-left:26px}
     .inner-box p:nth-child(5) img{margin-top:26px;cursor:pointer}
     .icon-info {
          width: 20px;
          height: 20px;
          border: 1px solid #a8abb3;
          padding: 4px;
          box-sizing: content-box;
          border-radius: 4px;
          vertical-align: middle;
     }
     .icon-more {
          width: 40px;
          height: 40px;
     }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue